import React from 'react';
import { Box, Button, Paper, Stack, SxProps, Theme, Typography } from '@mui/material';

import { useRouter } from '@cvt/routing';

interface AcademicArchetypeProps {
  archetype?: string | null;
  archetypeDescription?: string | null;
  showFindOut?: boolean;
  slots?: {
    share?: React.ReactNode;
  };
  sx?: SxProps<Theme>;
}

export const AcademicArchetype: React.FC<AcademicArchetypeProps> = ({
  archetype,
  archetypeDescription,
  showFindOut = false,
  slots,
  sx,
}) => {
  const router = useRouter();

  if (!archetype) {
    if (!showFindOut) return null;

    return (
      <Box textAlign="center" py={1}>
        <Typography variant="body2" color="text.secondary" component="span">
          Academic Archetype:{' '}
        </Typography>
        <Button
          variant="text"
          size="small"
          onClick={() => router.home.go()}
          sx={{ textDecoration: 'underline', fontWeight: 600 }}
        >
          Find Out
        </Button>
      </Box>
    );
  }

  return (
    <Paper variant="elevation" elevation={1} sx={{ p: 2, textAlign: 'center', width: '100%', ...sx as object }}>
      <Stack spacing={1} alignItems="center">

        <Stack direction={{ xs: 'column', md: 'row' }} alignItems="center" spacing={{ xs: 0, md: 1 }}>
          <Typography variant="h5" fontWeight={700} color="text.secondary">
            Your Academic Archetype:
          </Typography>
          <Typography
            variant="h5"
            fontWeight={700}
            fontFamily="'Rubik', sans-serif"
          >
            {archetype}
          </Typography>
        </Stack>
        {archetypeDescription && (
          <Typography variant="body2" color="text.secondary">
            {archetypeDescription}
          </Typography>
        )}
        {slots?.share}
      </Stack>
    </Paper>
  );
};
